import { AxiosResponse } from 'axios';
import api from 'api/base';
import { PermissionsResponse } from 'features/admin-permissions/api/types';

export const getPermissionsList = async (params: {
  partnerName?: string;
}): Promise<AxiosResponse<PermissionsResponse>> => {
  return api.get<PermissionsResponse>('/admin/permissions/partner', { params });
};
